// 2023-11-15 少儿频道-国学小名士 首页定制
export var QUES_KEY_2023_11_15 = '5561a980be0d47b8ae37ed0577e7755c';

// 2023-4-12 闪电新闻特殊问卷调整样式
export var QUES_KEY_2023_4_12 = 'faf8b4a4354a4aadaddf7bb9d60e3ded';

// 225机构这两套卷子的图片大小不限制
export var QUES_KEY_225_1 = 'b7355352ba92453c978d402f13fc67f8';
export var QUES_KEY_225_2 = 'd98518fadce04151aad478c21203705b';

// 莒南机构
export var JUNAN_ORG_ID = 105;

// 今日历下机构
export var JINRILI_ORG_ID = 197;

// 山东县融机构
export var SHANDONG_XIANRONG_ORG_ID = 519;